var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeTrackingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z",
    fill: "#009379",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13051_8988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8493 26.1507C51.8828 22.1843 46.6094 20 41 20C35.3907 20 30.1172 22.1843 26.1507 26.1507C22.1843 30.1172 20 35.3907 20 41C20 46.6093 22.1843 51.8828 26.1507 55.8493C30.1172 59.8157 35.3907 62 41 62C46.6094 62 51.8828 59.8157 55.8493 55.8493C59.8157 51.8828 62 46.6093 62 41C62 35.3907 59.8157 30.1172 55.8493 26.1507ZM41 59.2609C30.931 59.2609 22.7391 51.0691 22.7391 41C22.7391 30.9309 30.931 22.7391 41 22.7391C51.069 22.7391 59.2609 30.931 59.2609 41C59.2609 51.069 51.069 59.2609 41 59.2609Z",
    fill: "#009379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3696 28.4752H39.6304V41.5163L47.2755 50.2153L49.3331 48.4071L42.3696 40.4837V28.4752Z",
    fill: "#009379"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13051_8988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeTrackingIcon);
export default __webpack_public_path__ + "static/media/real-time-tracking-icon.59407259344d0edbbc8b2f1599f1b9a2.svg";
export { ForwardRef as ReactComponent };